<template>
    <div class="img-upload" :class="{ papers: isPapers }">
        <a-upload-dragger :action="action" :file-list="fileLists" list-type="picture-card" accept="image/*"
                  :before-upload="beforeUpload" :custom-request="customRequest" @preview="onPreview" @change="onChange"
                  v-bind="$attrs">
            <div v-if="!showList && fileLists.length < 1">
                <loading-outlined v-if="loading" />
                <plus-outlined v-else />
                <div class="ant-upload-text">点击或拖拽上传</div>
            </div>
        </a-upload-dragger>
        <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false" title="图片预览">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>

<script>
import { ref, toRefs, watch } from "vue";
import { message } from "ant-design-vue";
import { file_service } from "@/api/adminService";
import axios from "axios";
import Message from "ant-design-vue/lib/message";
// import { ls } from "@/utils/util";

export default {
    name: "ImgUpload",
    emits: [
        "change",
        "update:value"
    ],
    props: {
        value: {
            type: String,
        },
        size: {
            type: Number,
            default: 6,
        },
        count: {
            type: Number,
            default: 1,
        },
        isPapers: {
            type: Boolean,
            default: false,
        },
        showList: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const action = ref(file_service.upload);
        const previewVisible = ref(false);
        const previewImage = ref("");
        const loading = ref(false);
        const fileLists = ref([]);
        const { value } = toRefs(props);
        watch(
            value,
            (value) => {
                if (value) {
                    // const blob = new Blob([data.data], {type: "application/vnd.ms-excel;charset=utf-8"});
                    // const url = window.URL.createObjectURL(blob);
                    fileLists.value = value.split(",")
                        .filter(v => v)
                        .map((v) => {
                            return {
                                uid: v,
                                name: v.split('|')[1],
                                status: "done",
                                url: '',
                            };
                        });
                    fileLists.value.forEach(item => {
                        file_service.getImgUrl(item)
                    })
                } else {
                    fileLists.value = [];
                }
            },
            { immediate: true }
        );
        const beforeUpload = (file) => {
            return new Promise((resolve, reject) => {
                if (["image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(file.type) < 0) {
                    message.warning("请上传图片");
                    reject();
                }
                if (file.size > props.size * 1024 * 1024) {
                    message.warning("请上传不超过" + props.size + "M的图片");
                    reject();
                }
                resolve();
            });
        };
        const onPreview = (file) => {
            previewImage.value = file.url;
            previewVisible.value = true;
        };

        const onChange = ({ file, fileList }) => {
            // fileLists.value = fileList;
            switch (file.status) {
                case "uploading":
                    loading.value = true;
                    break;
                case "done":
                    loading.value = false;
                    break;
                case "removed":
                    loading.value = false;
                    updateValue(fileList);
                    break;
                case "error":
                    loading.value = false;
                    message.warning("上传失败");
                    break;
                default:
                    loading.value = false;
                    break;
            }
        };
        const customRequest = async (info) => {
            const { action, fileName, file } = info;
            let resData = await uploadFilesToServer(action, fileName, file)
            let { code = 200, data = "", msg = "ok" } = resData;
            if (code === 200) {
                updateValue([...fileLists.value, { uid: data }]);
            } else {
                Message.warn(msg);
            }
        }
        const uploadFilesToServer = (uploadApiUrl, fileName = 'file', files) => {
            let formData = new FormData();
            formData.append(fileName, files);
            // const headers = {
            //     "Content-Type": "multipart/form-data",
            //     Authorization: 'Bearer' + ls.get('token') || ''
            // };
            const request = axios.create({
                // headers: headers,
            });
            return request
                .post(uploadApiUrl, formData)
                .then((response) => {
                    return Promise.resolve(response.data);
                })
                .catch((error) => {
                    Message.warn("上传失败");
                    return Promise.reject(error);
                })
                .finally(() => {
                    loading.value = false;
                });
        }

        const updateValue = (fileList = []) => {
            let value = fileList.map((item) => item.uid)
                .join(",");
            emit("update:value", value);
            emit("change", value);
        };
        return {
            action,
            previewVisible,
            previewImage,
            loading,
            fileLists,
            beforeUpload,
            onPreview,
            onChange,
            customRequest
        };
    },
};
</script>
<style scoped>
</style>

